import { Add } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import FormAutocompleteMulti from "app/components/form-components/FormAutocompleteMulti";
function AddBenefits({ control, setOpenBenefitDialog, savedBenefits, benefits }) {
  return (
    <>
      <Box display={"flex"} gap={2} alignItems={"center"}>
        <h3>Benefits</h3>
        <Button
          variant={"outlined"}
          endIcon={<Add />}
          size="small"
          onClick={() => setOpenBenefitDialog(true)}
          style={{ paddingY: 0, maxHeight: "30px" }}
        >
          <Typography variant="body2">Add Benefit</Typography>
        </Button>
      </Box>
      <Box>
        <FormAutocompleteMulti
          control={control}
          name={"jp_benefits"}
          defaultValue={savedBenefits}
          label={"Job Benefits *"}
          helperText={"Job benefits is required"}
          isOptionEqualToValue={(option, value) => {
            return option.jp_id === value.jp_id;
          }}
          values={
            benefits
              ? benefits.map((benefit) => ({
                  jp_id: benefit.jp_id,
                  label: benefit.jp_benefit
                }))
              : []
          }
        />
      </Box>
    </>
  );
}

export default AddBenefits;
